import { executeFileBrowserList } from '../../../../files/browser/execute-file-browser-list.js';
import { resolveGitBranchScope } from '../../../../files/browser/resolve-git-branch-scope.js';
import type { ShortcutHandlerContext } from '../../../lib/types.js';
import { sendShortcutFileBrowserJson, sendShortcutJson } from '../../../lib/response.js';
import { parseGitScopeFromUrl, parseListPath } from './parse-query.js';
import { resolveShortcutSessionParent } from './resolve-session-parent.js';

export async function handleShortcutFileBrowserList(
  ctx: ShortcutHandlerContext,
  sessionId?: string,
): Promise<void> {
  const reqPath = parseListPath(ctx.url);
  const gitMsg = parseGitScopeFromUrl(ctx.url);
  const gitScope = resolveGitBranchScope({ id: 'shortcut', path: reqPath, ...gitMsg });
  if (
    gitMsg.source === 'git_branch' &&
    typeof gitMsg.repoRelPath === 'string' &&
    typeof gitMsg.branch === 'string' &&
    gitMsg.branch.trim().length > 0 &&
    !gitScope
  ) {
    sendShortcutJson(ctx.res, 400, { error: 'Invalid repository path' });
    return;
  }

  const sessionParentPath = await resolveShortcutSessionParent(ctx, sessionId);
  const result = await executeFileBrowserList({ reqPath, sessionParentPath, gitScope });
  if ('error' in result) {
    sendShortcutJson(ctx.res, 400, { error: result.error });
    return;
  }
  sendShortcutFileBrowserJson(ctx.res, 200, { entries: result.entries }, ctx.e2ee);
}
